import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66ae9dd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "instruction" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 测试推送前，请确保您已关闭微信公众号（云雀数据）的消息免打扰。如未关闭，可按以下步骤操作。", -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "manual-page-btns" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("推送测试（10秒后会收到公众号消息）")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      title: "推送通知向导",
      "left-text": "返回",
      "left-arrow": "",
      onClickLeft: _ctx.goBack
    }, null, 8, ["onClickLeft"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("img", {
          style: {"width":"100%"},
          src: require('@/assets/img/wechat-noti-tip1.jpeg')
        }, null, 8, _hoisted_4),
        _createElementVNode("img", {
          style: {"width":"100%","margin-top":"10px"},
          src: require('@/assets/img/wechat-noti-tip2.jpeg')
        }, null, 8, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_van_button, {
          type: "primary",
          block: "",
          class: "test-btn",
          onClick: _ctx.testPush
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ], 64))
}